import React, { Component } from 'react';
import { withRouter } from 'react-router';
import volunteerSectionService from './VolunteerSectionService';
import { Button } from 'reactstrap';

class VolunteerSectionDeletePlain extends Component {
	constructor(props) {
		super(props);
		this.state = { users: [], loading: true };

		const { match } = this.props;
		this.id = match.params.id;
	}

	componentDidMount() {

	}

	handleClickOk = () => {
		const { history } = this.props;

		(async () => {
			await volunteerSectionService.delete(this.id);
			history.push('/volunteersections');
		})();
	}

	handleClickCancel = () => {
		const { history } = this.props;

		history.push('/volunteersections');
	}

	render() {
		return (
			<div>
				<h2>Are you sure you want to delete volunteer section ?</h2>

				<button onClick={this.handleClickOk}>Yes</button>
				<button onClick={this.handleClickCancel}>No</button>
			</div>
		);
	}
}
export const VolunteerSectionDelete = withRouter(VolunteerSectionDeletePlain);